import _extends from "@babel/runtime/helpers/extends";
import classNames from 'classnames';
import React, { useMemo, useRef } from 'react';
import { TextButton, TextButtonPriority, TextField, TextFieldTheme } from '@wix/wix-ui-tpa/cssVars';
import { useConfig } from '../../contexts/config-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useTranslation } from '../../contexts/translation-context';
import { deserialize, serialize } from './helpers';
import { TimeInput } from './time-input/time-input';
import { classes } from './time-picker-wut.st.css';
import { FieldLabelWUT } from '../field-label/field-label-wut';
export function TimePickerWUT(_ref) {
  let {
    value,
    onChange,
    className,
    disabled,
    hidePlaceholder,
    use24Hours,
    readOnly,
    showTimeLabel,
    inputId,
    ...rest
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const {
    t
  } = useTranslation();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const nativeRef = useRef(null);
  const ampmRef = useRef(null);
  const minutesRef = useRef(null);
  const placeholderValue = useMemo(() => hidePlaceholder ? '--:--' : t('field.date.placeholder.time'), [hidePlaceholder, t]);
  const {
    hours,
    minutes,
    period
  } = deserialize(value, use24Hours);
  const periodText = t(`field.time.perdiod.${period}`);
  const focusOnAMPM = () => {
    var _ampmRef$current;
    (_ampmRef$current = ampmRef.current) == null || _ampmRef$current.focus();
  };
  const handleNativeChange = event => {
    var _event$target;
    const [newHours, newMinutes] = (((_event$target = event.target) == null ? void 0 : _event$target.value) ?? '').split(':');
    onChange(serialize(newHours, newMinutes));
  };
  const showPicker = () => {
    if (isMobile) {
      var _nativeRef$current;
      (_nativeRef$current = nativeRef.current) == null || _nativeRef$current.showPicker();
    }
  };
  const handlePeriodToggle = () => {
    if (readOnly) {
      return;
    }
    onChange(serialize(hours, minutes, period === 'AM' ? 'PM' : 'AM', use24Hours));
  };
  const handleAMPMKeyDown = event => {
    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowUp':
        {
          handlePeriodToggle();
          break;
        }
      case 'ArrowLeft':
        {
          var _minutesRef$current;
          (_minutesRef$current = minutesRef.current) == null || _minutesRef$current.focus();
          break;
        }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    onClick: showPicker,
    className: classNames(classes.root, className)
  }, /*#__PURE__*/React.createElement(FieldLabelWUT, {
    labelId: `form-field-sub-label-time-${inputId}`,
    label: t('field.date.label.time'),
    hideLabel: !showTimeLabel,
    required: false
  }), /*#__PURE__*/React.createElement(TextField, _extends({}, rest, {
    theme: TextFieldTheme.Box,
    newErrorMessage: true,
    disabled: disabled,
    inputClassName: classes.hidden,
    className: classNames(className, classes.textField, classes.theme, {
      [classes.error]: rest.error,
      [classes.hover]: forcedHover
    }),
    prefix: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      tabIndex: -1,
      type: "time",
      ref: nativeRef,
      value: value,
      "data-time-field": true,
      hidden: !isMobile,
      onChange: handleNativeChange,
      className: classes.native
    }), /*#__PURE__*/React.createElement(TimeInput, {
      inputId: inputId,
      placeholder: placeholderValue,
      onChange: (newHours, newMinutes, newPeriod) => {
        onChange(serialize(newHours, newMinutes, newPeriod ?? period, use24Hours));
      },
      disabled: disabled,
      value: value,
      use24Hours: use24Hours,
      onNext: focusOnAMPM,
      minutesRef: minutesRef,
      readOnly: readOnly
    }), !use24Hours && /*#__PURE__*/React.createElement(TextButton, {
      "data-time-field": true,
      "aria-label": `${t('field.time.label.period')} ${periodText}`,
      "data-hook": "ampm",
      onClick: handlePeriodToggle,
      onKeyDown: handleAMPMKeyDown,
      className: classNames([classes.period, (hours || minutes) && classes.period__active]),
      priority: TextButtonPriority.secondary,
      "aria-live": "polite",
      ref: ampmRef
    }, periodText))
  })));
}
//# sourceMappingURL=time-picker-wut.js.map